'use client';

import * as React from 'react';

import {useDefaultProps} from '../theme/useDefaultProps';

import {TabContext} from './contexts/TabContext';
import {useTabPanel} from './hooks/useTabPanel';
import type {TabPanelProps} from './types';

import './TabPanel.scss';

export const TabPanel = React.forwardRef<HTMLDivElement, TabPanelProps>((rawProps, ref) => {
    const props = useDefaultProps('TabPanel', rawProps);
    const panelProps = useTabPanel(props);
    return (
        <TabContext.Provider value={undefined}>
            <div ref={ref} {...panelProps}>
                {props.children}
            </div>
        </TabContext.Provider>
    );
});

TabPanel.displayName = 'TabPanel';
